export interface CommercialProducts {
  michelin_new_tires: boolean,
  x_one_tires: boolean,
  bfgoodrich_tires: boolean,
  uniroyal_tires: boolean,
  truck_associate_dealer: boolean,
  travel_plaza: boolean,
  mrt_dealer: boolean,
  mrt_associate_dealer: boolean,
  oliver_retreads: boolean,
  megamile_retreads: boolean,
  ultra_low_profile_wide_design_retreads: boolean,

  // Earthmover Products
  material_handling: boolean,
  off_the_road: boolean,
  small_earthmover: boolean,
  large_material_handling: boolean,
  giant_earthmover: boolean,

  // Agricultural Products
  authorized_michelin_ag_tires_supplier: boolean,
  r4_compact_line: boolean,
  key_associate_dealer: boolean,
}

export interface CommercialProducts_MassST {
  x_one_tires: boolean,
  mrt_dealer: boolean,
  oliver_retreads: boolean,
  megamile_retreads: boolean,
  ultra_low_profile_wide_design_retreads: boolean,
}

export const CommercialProductsFields_MassST = {
  x_one_tires: 'X One Tires',
  mrt_dealer: 'MRT Dealer',
  oliver_retreads: 'Oliver Retreads',
  megamile_retreads: 'MegaMile Retreads',
  ultra_low_profile_wide_design_retreads: 'Ultra Low Profile Wide Design Retreads',
};

const commercialProductFields = {
  // commercial truck products
  michelin_new_tires: {
    label: 'Michelin New Tires',
    detail: null,
  },
  x_one_tires: {
    label: 'X One Tires',
    detail: null,
  },
  bfgoodrich_tires: {
    label: 'BFGoodrich Tires',
    detail: null,
  },
  uniroyal_tires: {
    label: 'Uniroyal Tires',
    detail: null,
  },
  truck_associate_dealer: {
    label: 'Truck Associate Dealer',
    detail: null,
  },
  travel_plaza: {
    label: 'Travel Plaza',
    detail: null,
  },
  mrt_dealer: {
    label: 'MRT Dealer',
    detail: null,
  },
  mrt_associate_dealer: {
    label: 'MRT Associate Dealer',
    detail: null,
  },
  oliver_retreads: {
    label: 'Oliver Retreads',
    detail: null,
  },
  megamile_retreads: {
    label: 'MegaMile Retreads',
    detail: null,
  },
  ultra_low_profile_wide_design_retreads: {
    label: 'Ultra Low Profile Wide Design Retreads',
    detail: null,
  },

  // Earthmover Products
  material_handling: {
    label: 'Material Handling',
    detail: 'Industrial < 22.5" rim diameter',
  },
  off_the_road: {
    label: 'Off The Road',
    detail: '<14.00R24 & 25" rim diameter & 385/95R24 & 25 < rim diameter',
  },
  small_earthmover: {
    label: 'Small Earthmover',
    detail: '< 23.5R25, 18.00R33 & 16.00R24',
  },
  large_material_handling: {
    label: 'Large Material Handling',
    detail: 'Port Tires > 24" rim diameter & X-TERMINAL T™',
  },
  giant_earthmover: {
    label: 'Giant Earthmover',
    detail: '> 51" rim diameter',
  },

  // Agricultural Products
  authorized_michelin_ag_tires_supplier: {
    label: 'Authorized Michelin AG Tires Supplier',
    detail: null,
  },
  r4_compact_line: {
    label: 'R4 Compact Line',
    detail: null,
  },
  key_associate_dealer: {
    label: 'Key Associate Dealer',
    detail: null,
  },
} as any;

export function commercialProductFieldLabel(field: string): string {
  return commercialProductFields[field].label;
}

export function commercialProductFieldDetail(field: string): string | null {
  return commercialProductFields[field].detail;
}
